import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { haveValue } from "../helper/common";
import { useCookies } from "react-cookie";

const RedirectPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);

  useEffect(() => {
    // Get the query parameters from the URL
    const queryParams = new URLSearchParams(location.search);
    // Extract the token from the query parameters
    const token = queryParams.get("token");
    const publicKey = queryParams.get("publicKey");
    const usertype = queryParams.get("usertype");
    const is_verified = queryParams.get("is_verified");
    const saveduserid = queryParams.get("saveduserid");
    const external_customer_id = queryParams.get("external_customer_id");
    const app_type = queryParams.get("app_type");
    const goToPage = queryParams.get("go_to_page");
    // const guarantorFor = queryParams.get("guarantorFor");

    localStorage.setItem("token", token);
    if (haveValue(publicKey)) {
      localStorage.setItem("publicKey", publicKey);
    }
    localStorage.setItem("usertype", usertype);
    localStorage.setItem("is_verified", is_verified);
    localStorage.setItem("saveduserid", saveduserid);
    localStorage.setItem("external_customer_id", external_customer_id);
    localStorage.setItem("app_type", app_type);
    localStorage.setItem("loggedin_by", "admin");

    if (usertype === "tenant") {
      // if (haveValue(guarantorFor)) {
      //   localStorage.setItem("guarantorFor", guarantorFor);
      // }
      if (haveValue(goToPage)) {
        navigate(goToPage);
      } else {
        navigate("/tenant");
      }
    } else {
      if (haveValue(goToPage)) {
        navigate(goToPage);
      } else {
        navigate("/home");
      }
    }
  }, [location]);
  return "RedirectPage";
};

export default RedirectPage;
